
export default {
  methods: {
    isPremium(workoutBlock) {
      return workoutBlock.price > 0 && workoutBlock.productVariant && workoutBlock.type == "CHALLENGE";
    },
  },
};
